import { render, staticRenderFns } from "./DependencyVersion.vue?vue&type=template&id=00c0701d&"
import script from "./DependencyVersion.vue?vue&type=script&lang=js&"
export * from "./DependencyVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports